import React from 'react'
import PropTypes from 'prop-types'

export const TitleSection = ({title}) => {
    return (
        <div className="title-content">
            <h1 className="title-section">
                <span className="title-section-span">{title}</span>
            </h1>
        </div>
    )
}

TitleSection.propTypes = {
    title: PropTypes.string.isRequired
}